import axios from "axios";
import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#1A1253",
    color: theme.palette.common.white,
    fontSize: 26,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function DisplayTableCopy() {
  //state to store api data
  const [stateData, setStateData] = useState([]);
  //fetched data using axios libraray
  const getData = () => {
    axios
      .get("https://webnior.herokuapp.com/register/state")
      .then((response) => {
        // console.log(response);
        setStateData(response.data.states);
      });
  };
  // console.log(stateData);
  useEffect(() => getData(), []);
  return (
    <>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>State Name </StyledTableCell>
              <StyledTableCell>Total Transaction</StyledTableCell>
              <StyledTableCell>FTO Generated</StyledTableCell>
              <StyledTableCell>Population</StyledTableCell>
              <StyledTableCell>Year</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {stateData.map((data) => (
              <StyledTableRow>
                <StyledTableCell>{data.State_Name}</StyledTableCell>

                <StyledTableCell>{data.Total_Transaction}</StyledTableCell>
                <StyledTableCell>{data.FTO_GENRATED}</StyledTableCell>
                <StyledTableCell>{data.POPULATION}</StyledTableCell>
                <StyledTableCell>{data.YEAR}</StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

export default DisplayTableCopy;
